<template>
  <el-dialog
    width="35%"
    class="dialog"
    :title="`保证金${type === 'payment' ? '缴纳' : '扣除'}`"
    :visible.sync="dialogFormVisible"
    :close-on-click-modal="false"
  >
    <el-form
      ref="ruleForm"
      label-position="right"
      :rules="rules"
      :model="formData"
      label-width="120px"
    >
      <el-form-item label="保证金总额"> {{ formData.bondAmount }}</el-form-item>
      <el-form-item label="已占用保证金">
        {{ formData.usedBondAmount }}
      </el-form-item>
      <el-form-item label="未占用保证金">
        {{ formData.unuseBondAmount }}</el-form-item
      >
      <el-form-item
        :label="`${type === 'payment' ? '缴纳' : '扣除'}金额`"
        prop="amount"
      >
        <el-input v-model="formData.amount" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="凭证" prop="fileId">
        <image-upload
          :imageUrl.sync="formData.fileId"
          :editMode="true"
          @success="uploadSuccess($event, 'fileId')"
          :maxSize="5"
          :appendToBody="true"
        />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="primary" :loading="btnLoading" @click="submitBtnFun"
        >保存</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
import { amountReg, deductAmountReg } from "@/hooks/regex";
import { operatePartnerBond } from "@/api/oldForNew";
import imageUpload from "@/components/Upload/ImageUpload";

export default {
  components: {
    imageUpload
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入金额"));
      } else {
        if (this.type == "payment") {
          let amountReg = new RegExp(/^(0|([1-9]\d{0,7}))(\.\d{1,2})?$/).test(
            value
          );
          if (amountReg) {
            callback();
          } else {
            callback(
              new Error("请输入正确的金额，不超过100,000,000，最多两位小数")
            );
          }
        } else {
          let deductAmountReg = new RegExp(/^[0-9]*\.?[0-9]{0,2}$/).test(value);
          if (deductAmountReg) {
            if (value > this.formData.bondAmount) {
              callback(new Error("扣除金额需要小与等于保证金总额"));
            } else {
              callback();
            }
          } else {
            callback(
              new Error(
                `请输入正确的扣除金额，不超过${this.formData.bondAmount}，最多两位小数`
              )
            );
          }
        }
      }
    };
    return {
      id: "",
      dialogFormVisible: false,
      imageUrls: [],
      type: "", //缴纳/扣除
      formData: {
        operateType: this.type === "payment" ? 1 : 4,
        partnershipId: "",
        amount: 0,
        bondAmount: "",
        fileId: "" //上传凭证
      },
      rules: {
        amount: [
          { required: true, message: "请输入金额", trigger: "blur" },
          {
            validator: validatePass,
            trigger: "blur"
          }
        ],
        fileId: [{ required: true, message: "请上传凭证", trigger: "blur" }]
      },
      btnLoading: false
    };
  },
  watch: {
    dialogFormVisible: function(val, oldVal) {
      if (!val) {
        this.$refs.ruleForm.resetFields();
      }
    },
    "formData.fileId": function(newVal) {
      console.log("newVal", newVal);
      if (newVal) {
        this.$refs.ruleForm.clearValidate("fileId");
      }
    }
  },
  computed: {},
  methods: {
    // 关闭弹框
    closeDialog() {
      this.dialogFormVisible = false;
    },
    // 打开弹框
    async openDialog(formData, flag) {
      this.formData = formData; //todo
      this.type = flag;
      this.dialogFormVisible = true;
    },
    // 确认提交
    submitBtnFun() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.save();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 保存和编辑数据接口
    async save() {
      this.btnLoading = true;
      let params = {
        operateType: this.type === "payment" ? 1 : 4,
        partnershipId: this.formData.partnershipId,
        amount: Number(this.formData.amount),
        fileId: this.formData.fileId
      };
      let { statusCode, message } = await operatePartnerBond(params);
      if (statusCode == 200) {
        this.$message.success("保存成功");
        this.dialogFormVisible = false;
        this.$emit("opera-success");
      } else {
        this.$message.error(message);
      }
      this.btnLoading = false;
    },
    // 表单重置
    resetFormStatus() {
      this.$refs.ruleForm.resetFields();
    },
    async uploadSuccess(val, flag) {
      // this.formData[flag] = val;
      this.$set(this.formData, flag, val);
      console.log("this.formData", this.formData);
    }
  }
};
</script>
<style scoped lang="scss">
.dialog {
  padding: 0 20px;
  .tips {
    margin-bottom: 10px;
  }
  .el-dialog__body {
    padding-top: 10px;
  }
  .dialog-footer {
    padding: 20px;
    padding-top: 0;
  }
  .el-form-item--small.el-form-item {
    &.read-only {
      margin-bottom: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/oldForNewService/components/earnestMoneyModal.vue